/**
 * Create data with expiring date.
 * @param {number} maxMilliseconds Max milliseconds that the resulting cache
 * will store the data.
 */
function createCache(maxMilliseconds) {
  const cache = {
    /** @type {number} Date (in milliseconds) when the cache expires */
    expires: null,
    /** @type {any} Cached value */
    data: null,
  };

  /**
   * Clear the cached value
   */
  function clear() {
    delete cache.data;
    cache.data = null;
    cache.expires = null;
  }

  /**
   * Get the cached value. If the cache has expired, returns null.
   * @returns {any|null} Cached data or empty value (null).
   */
  function get() {
    if (Date.now() > cache.expires) {
      clear();
    }
    return cache.data;
  }

  /**
   * Set a value in cache
   * @param {any} data Data to be cached
   */
  function set(data) {
    cache.data = data;
    cache.expires = Date.now() + maxMilliseconds;
  }

  return {
    clear,
    get,
    set,
  };
}

export default createCache;
